import axios from "axios";
import Vue from 'vue';
import {
  Message
} from "element-ui";
import router from '../router/index';
import store from '../store/index'
Vue.use(router);
Vue.component(Message);
Vue.prototype.$message = Message;

// let token = "";
// token = localStorage.getItem("token")

const server = axios.create({
  baseURL: "http://110.87.103.59:18086/",
  timeout: 50000
});

// 添加一个请求拦截器
server.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: store.state.token
      }
    }
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

let lateFlag = 0
// 添加一个响应拦截器
server.interceptors.response.use(function (response) {
  if (response.data.code === 401) {
    if (lateFlag === 0) {
      Message({
        message: "登录信息失效，请您重新登录",
        type: "error",
        showClose: true,
        duration: 2000,
        onClose: () => {
          lateFlag = 0
        }
      });
      lateFlag++
      router.push('/login')
    }
  }
  return response.data;
});

export default server;
